import { observable, action } from 'mobx'

export const store = observable({ coins: [] })

export const setCoins = action(coins => (store.coins = coins))
